import React, { useEffect, useRef, useState } from 'react'
import './secret-codes-list.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faFilter, faPen, faPlus, faPrint, faUpload } from '@fortawesome/free-solid-svg-icons';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import CategoryFilterModal from '../components/category-filter-modal.component';
import { format } from 'date-fns';
import { stripHtml } from '@/utils/sanitize';
import { Link, useNavigate } from 'react-router-dom';
import SecretCodeUploadModal from './upload-modal.component';
import VisibilityButton from '../components/visibility-button.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { useSelector } from 'react-redux';
import ManagerElementListItem from '@/components/SHARED/manager-element-list-item/manager-element-list-item.component';
import ManagerElementListMenu from '@/components/SHARED/manager-element-list-menu/manager-element-list-menu.component';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';

const SecretCodesList = ({
    gameElements,
    secretCodesFromDb,
    gameData,
    role }) => {
    
    const membership = useEffectiveMembership();
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ filteredElements, setFilteredElements ] = useState([]);
    const [ showFilterModal, setShowFilterModal ] = useState(false);
    const [ contentToDisplay, setContentToDisplay ] = useState([]);
    const [ categoryList, setCategoryList] = useState([]);
    const [ selectedCategories, setSelectedCategories ] = useState([]);
    const [ showUploadModal, setShowUploadModal ] = useState(false);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const [ menuCategory, setMenuCategory ] = useState('visible');
    const [ dropdown, setDropdown ] = useState(null);
    const catRef = useRef([]);
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (!gameElements) {return;}
    //     setContentToDisplay(filteredElements.filter(a => a.type === 'secretCode'))
    //     setCategoryList([...new Set(filteredElements.filter(c => c.type === 'secretCode' && c.opt_cat).map(c => c.opt_cat))]);
    // }, [gameElements])

    useEffect(() => {
        chooseCategory();
    }, [filteredElements])

    function checkMembership(e) {
        const res = testMemberRestrictions({'gameData':gameData, 'membership':membership, 'create': true});
        if (res.disabled && res.disabledReason.includes('elements')) {
            const planRest = membershipRestrictions[membership.membership];
            const message = `While using the ${planRest.title}, you are only able to have ${planRest.elementCount} active Game Elements per game.`;
            setShowUpgradeModal(message);
            return;
        }
        if (e === 'upload') {
            navigate('upload');
            return;
        }
        navigate('create');
    }

    function chooseCategory(e) {
        if (e) {
            let catList = [...catRef.current];
            if (catList.includes(e)) {
                catList.splice(catList.indexOf(e), 1)
            } else {
                catList.push(e)
            }
            catRef.current = catList;
            setSelectedCategories(catRef.current);
        }
        if (catRef.current.length > 0) {
            setContentToDisplay(filteredElements.filter(a => a.type === 'secretCode' && catRef.current.includes(a.opt_cat)))
        } else {
            setContentToDisplay(filteredElements.filter(a => a.type === 'secretCode'))
        }
    }

    function search(e) {
        if (!e) {
            setContentToDisplay(filteredElements.filter(a => a.type === 'secretCode'))
            return;
        }
        setContentToDisplay(filteredElements.filter(a => a.type === 'secretCode' && (a.name.toLowerCase().includes(e) || a.desc && a.desc.toLowerCase().includes(e))))
    }

    
    return (
        <div className={`secret-code-list ${screenSize}`}>
            {
                (screenSize !== 'mobile' && screenSize !== 'tablet') &&
                <ManagerElementListMenu
                    gameElements={gameElements}
                    elementsFromDb={secretCodesFromDb}
                    type='secretCode'
                    setContentToDisplay={setContentToDisplay}
                    setDropdown={setDropdown}
                    setSelectedCategories={setSelectedCategories}
                    setFilteredElements={setFilteredElements}
                    setCategoryList={setCategoryList}
                    menuCategory={menuCategory}
                    setMenuCategory={setMenuCategory}
                    catRef={catRef} />
            }
            <div className='secret-code-list-content'>
                <div className='buttons'>
                    <button
                        className={`g-button med-btn ${role !== 'manager' && role !== 'owner' ? 'disabled' : ''}`}
                        onClick={() => checkMembership()} >
                        Create a Code
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                    <Link to={`/printsecretcodes/${gameData.path}`} target='_blank'>
                        <button
                            className='g-button med-btn'
                            title="Print Secret Code Cards" >
                            <FontAwesomeIcon icon={faPrint} />
                        </button>
                    </Link>
                </div>
                {
                    (screenSize === 'mobile' || screenSize === 'tablet') &&
                    <>
                    <div className="g-space-1"></div>
                    <ManagerElementListMenu
                        gameElements={gameElements}
                        elementsFromDb={secretCodesFromDb}
                        type='secretCode'
                        setContentToDisplay={setContentToDisplay}
                        setDropdown={setDropdown}
                        setSelectedCategories={setSelectedCategories}
                        setFilteredElements={setFilteredElements}
                        setCategoryList={setCategoryList}
                        menuCategory={menuCategory}
                        setMenuCategory={setMenuCategory}
                        catRef={catRef} />
                    </>
                }
                <div className="g-space-1"></div>
                <div className='secret-code-list-search'>
                    <SearchBar search={search} />
                    <button 
                        title='Filter by Category'
                        type='button' 
                        className='g-button med-btn' 
                        onClick={() => setShowFilterModal(true)} >
                        <FontAwesomeIcon 
                            icon={faFilter}
                            className={selectedCategories.length > 0 ? 'full' : 'empty'} 
                        />
                    </button>
                    <button
                        title='Upload a List'
                        type='button'
                        className={`g-button med-btn ${role !== 'manager' && role !== 'owner' ? 'disabled' : ''}`}
                        onClick={() => checkMembership('upload')} >
                        <FontAwesomeIcon icon={faUpload} />
                    </button>
{/*                     
                        <button 
                            title='Create a New Secret Code'
                            type='button' 
                            className='g-button med-btn' 
                            onClick={() => checkMembership('create')} >
                            <FontAwesomeIcon icon={faPlus} />
                        </button> */}
                </div>
                <div className="g-space-1"></div>
                <div className='secret-code-list-div'>
                    {
                       (screenSize !== 'mobile' && screenSize !== 'tablet') &&
                        <>
                        <div className='g-list-item secret-code-list-head element-list-row meta'>
                            <div></div>
                            <div>Secret Code</div>
                            {/* <div>Description</div> */}
                            <div>Status</div>
                            <div></div>
                        </div>
                        <div className='g-space-0-5'></div>
                        </>
                    }
                    <div className='secret-code-list'>
                        {
                            (contentToDisplay.length > 0)
                            ?
                            contentToDisplay.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                            .map(c => {
                                let now = new Date().getTime();
                                let status = 'Available';
                                if (!c.opt_available) {
                                    status = 'Closed';
                                }
                                if (c.opt_dateOpen && now < c.opt_dateOpen) {
                                    status = 'Closed';
                                }
                                if (c.opt_dateClose && now > c.opt_dateClose) {
                                    status = 'Closed';
                                }
                                if (c.status !== 'active') {
                                    status = 'Deleted';
                                }
                                return (
                                    <div key={c.id}>
                                    <ManagerElementListItem
                                        gameElements={gameElements}
                                        gameData={gameData}
                                        element={c}
                                        dropdown={dropdown}
                                        setDropdown={setDropdown}
                                        dataPoint={status}
                                        role={role} />
                                    </div>
                                // <div key={c.id} className='g-list-item row'>
                                //     <ImageContainer src={c.icon} alt={`${c.name} secret code icon`} className='secret-code-icon' />
                                //     <div className='secret-code-name'>{c.name}</div>
                                //     <div className='secret-code-desc meta'>{c.desc && stripHtml(c.desc).substring(0,60)}{c.desc && stripHtml(c.desc).length > 60 ? '...' : ''}</div>
                                //     <div className='meta'>{c.opt_dateOpen ? format(new Date(c.opt_dateOpen), 'P') : format(new Date(c.ts_created), 'P')}</div>
                                //     <div className='meta'>{c.opt_dateClose ? format(new Date(c.opt_dateClose), 'P') : 'Indefinite'}</div>
                                //     <div className='buttons'>    
                                //         <VisibilityButton element={c} />
                                //         <button className='g-button med-btn' title='View secret code data'><FontAwesomeIcon icon={faChartPie} /></button>
                                //         <button className='g-button med-btn' onClick={() => navigate(`edit/${c.path}`)} title='Edit this secret code'><FontAwesomeIcon icon={faPen} /></button>
                                //     </div>
                                // </div>
                            )})
                            :
                            <p>No Secret Codes yet...</p>
                        }
                    </div>
                </div>
            </div>


            <CategoryFilterModal 
                show={showFilterModal} 
                cancel={() => setShowFilterModal(false)} 
                chooseCategory={chooseCategory} 
                categoryList={categoryList} 
                selectedCategories={selectedCategories} 
                color='var(--secret-code-color)'
            />

            <SecretCodeUploadModal
                show={showUploadModal}
                cancel={() => setShowUploadModal(false)}
                gameData={gameData}
            />

            <UpgradeRequiredModal
                show={showUpgradeModal}
                cancel={() => setShowUpgradeModal(false)}
                closeButton={true}
                message={showUpgradeModal}
            />
        </div>
    )
}

export default SecretCodesList